import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Card, CardHeader, CardBody } from 'components/common/card';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableHeadCell,
} from 'components/common/table';
import Input from 'components/common/input';

const LocationFinder = ({
  handleInput,
  value,
  enabledLocations,
  locationsFiltered,
  setLocation,
}) => {
  const locations = locationsFiltered.length ? locationsFiltered : enabledLocations;

  return (
    <Fragment>
      <Card>
        <CardHeader
          title="Filtrar ubicación"
          subtitle="Aquí puedes filtrar por nombre de las ubicaciones que se encuentren habilitadas"
        />
        <CardBody>
          <Input
            input
            type="text"
            label="Nombre de la ubicación"
            primary
            onChange={handleInput}
            value={value}
          />
        </CardBody>
      </Card>

      <Card marginT="50">
        <CardHeader
          title="Ubicaciones habilitadas"
          subtitle="Selecciona una ubicación para hacer un conteo"
        />
        <CardBody>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableHeadCell>Nombre</TableHeadCell>
                  <TableHeadCell>Número de conteos</TableHeadCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {locations.map(location => (
                  <TableRow
                    key={location.location.id}
                    clickable
                    hover
                    onClick={() => setLocation(location)}
                  >
                    <TableCell>{location.location.tag}</TableCell>
                    <TableCell>{location.versions}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardBody>
      </Card>
    </Fragment>
  );
};

LocationFinder.propTypes = {
  handleInput: PropTypes.func.isRequired,
  setLocation: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  enabledLocations: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  locationsFiltered: PropTypes.array.isRequired,
};

export default LocationFinder;
